import { RouteObject } from '@rocketlane/rocket-router';
import { PermissionSetType, UserType } from 'api/models';
import { useUserPermissionSetType } from 'hooks/permissions';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { usePartnerCompanyPermission } from 'hooks/use-partner';
import { useUser } from 'hooks/use-user';
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import {
  NotFoundPage,
  TimesheetFeatureDiscoveryPage,
  TimesheetsRoutes,
} from 'routes/vendor/lazy-imports';
// import { retryImportInsideRoutesDefinition } from 'utils/lazyWithRetry';

const TimesheetsRoutesLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { user } = useUser();
  const [isTimesheetFeatureEnabled] = useAccountFeature(
    AccountFeature.Timesheets,
  );
  const currentUserPermissionSetType = useUserPermissionSetType();

  const isAccountAdmin =
    currentUserPermissionSetType === PermissionSetType.AccountAdmin;

  const { canPartnerTrackTime } = usePartnerCompanyPermission();

  if (
    isTimesheetFeatureEnabled &&
    (user.userType === UserType.Native || canPartnerTrackTime)
  ) {
    return <>{children}</>;
  }

  if (isAccountAdmin) {
    return <TimesheetFeatureDiscoveryPage />;
  }

  return <NotFoundPage />;
};

export const timesheetRoutes: RouteObject = {
  path: `${ROUTE_PATHS.TIMESHEETS}/*`,
  element: (
    <SecureRoute rule="TIMESHEET:READ">
      <TimesheetsRoutesLayout>
        <TimesheetsRoutes />
      </TimesheetsRoutesLayout>
    </SecureRoute>
  ),
  // async lazy() {
  //   const { TimesheetsRoute } = await retryImportInsideRoutesDefinition(
  //     () => import('.'),
  //   );

  //   return {
  //     element: (
  //       <SecureRoute rule="TIMESHEET:READ">
  //         <TimesheetsRoutesLayout>
  //           <TimesheetsRoute />
  //         </TimesheetsRoutesLayout>
  //       </SecureRoute>
  //     ),
  //   };
  // },
};
